import React, {useEffect, useState} from 'react';
import Form_9View from './Form_9-view';
import {useRouteMatch} from "react-router-dom";
import {pathnames as P} from "common/constants/pathnames";
import UnmountHandler from "../UnmountHandler";

const Form_9 = ({getShumaStepStatus, allowInspectionsShare}) => {
  const [text, setText] = useState('');
  const [submitStep, setSubmitStep] = useState(true);
  const handleSearchTextChange = text => {
    setText(text);
  };
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);

  useEffect(() => {
    setSubmitStep(false)
  }, []);

  const handleGetShumaStepStatus = (shumaId) => {
    if (!submitStep) {
      getShumaStepStatus({shumaId})
    }
  }

  return (
    <>
      <UnmountHandler
        onLeavePage={handleGetShumaStepStatus}
        shumaId={shumaId}
      />
      <Form_9View
        searchText={text}
        onSearchChanged={handleSearchTextChange}
        prevPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 5)}
        nextPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 10)}
        allowInspectionsShare={allowInspectionsShare}
      />
    </>
  )
};

Form_9.propTypes = {};

export default Form_9;
